
export function saveCookie(name: string, token: string) {

}

export function getCookie(name: string) {
  
}

function rmCookie(name: string) {
  
}
export function removeCookie(name: string) {
  return rmCookie(name);
}
export function removeMultiCookie(name: string[]) {
  name.forEach((n: string) => {
    // /rmCookie(n);
  });
}

export function getAuthPath(path: string) {
  return `${process.env.REACT_APP_API_DOMAIN}${path}?secret=${process.env.REACT_APP_API_SECRET}`;
}
